module.exports = __webpack_public_path__ + "img/mes-scene-trace.fe48ece6.jpg";